export const environment = {
  URL: 'https://pat.dev.alpha.simadvisory.com',
  KEYCLOAK_URL: 'https://auth.alpha.simadvisory.com',
  KEYCLOAK_REALM: 'D_SPRICED',
  KEYCLOAK_CLIENT_ID: 'D_SPRICED_Client',
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  // CLIENT_LOGO_SRC — image URL. If set (Use Case 2), shown alone in toolbar.
  // If both CLIENT_LOGO_SRC and CLIENT_LOGO_ICON are empty (Use Case 1), default SIM Advisory branding is used.
  CLIENT_LOGO_SRC: "",
  // CLIENT_LOGO_ICON — mat-icon name (alternative to image URL). Used with CLIENT_LOGO_TEXT.
  CLIENT_LOGO_ICON: "",
  CLIENT_LOGO_TEXT: "",
  COMPANY_LOGO_SRC: "https://assets.alpha.simadvisory.com/logos/image.png",
  COMPANY_LOGO_TEXT: "PAT",
  // DEFAULT_COMPANY_LOGO — local SVG SIM Advisory logo; takes precedence over COMPANY_LOGO_SRC when set.
  DEFAULT_COMPANY_LOGO: "assets/default-company-logo.svg",
  // DEFAULT_MAKE_INDIA_LOGO — local SVG Make-in-India logo; takes precedence over SECONDARY_LOGO_SRC when set.
  DEFAULT_MAKE_INDIA_LOGO: "assets/default-make-in-India-logo.svg",
  SECONDARY_LOGO_SRC: "https://assets.alpha.simadvisory.com/Make-in-india.png",
  SECONDARY_COLOR: '#9ccafb',
  SECONDARY_COLOR_2: '#9ccafb',
  ICON_URL: "https://assets.alpha.simadvisory.com/logos/image.png",
  TAB_NAME: "PAT",
  HELP_ENABLED: "true",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "true",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  agentApiUrl: 'http://localhost:8081',
  THEME_NAME: 'default',
  USE_ALT_SIDENAV: false,
  ALT_COMPANY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/cummins_white.png',
  ALT_SECONDARY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/logos/sim-logo-white.png',
};
